(function () {

    'use strict';

    angular.module('iplusjs.popoverField', [
        'lodash'
    ])
        .component('iplusjsPopoverField', {
            require: {
                fieldset: '^?iplusjsFieldset'
            },
            bindings: {
                disabled: '<?ipfDisabled',
                type: '@ipfType',
                value: '<ipfValue',
                fieldName: '@ipfFieldName',
                label: '@ipfLabel',
                labelPopover: '@ipfLabelPopover',
                data: '<ipfData',
                dataProperties: '@ipfDataProperties',
                change: '&ipfChange',
                options: '<ipfOptions'
            },
            templateUrl: 'common/popoverfield/popoverField.html',
            controller: PopoverFieldController,
            controllerAs: 'popoverFieldVm'
        });

    PopoverFieldController.$inject = [
        '$scope',
        'lodash',
        'TrackingUtilsService'
    ];
    function PopoverFieldController($scope, _) {
        var vm = this;

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;
        vm.getBezeichnung = getBezeichnung;

        function activate() {
            vm.options = vm.options || {};
            vm.options.width = vm.options.width || 250;
            vm.properties = $scope.$eval(vm.dataProperties) || {
                trackBy: 'wert',
                bezeichnung: 'bezeichnung',
                orderBy: ''
            };
            vm.options.tracking = vm.options.tracking || {};
            vm.options.tracking.name = vm.options.tracking.name || vm.fieldName;

            vm.fieldPartialUrl = 'common/popoverfield/partials/popoverField' + _.upperFirst(vm.type) + '.html';
            vm.trackBy = vm.properties.trackBy ? 'value.' + vm.properties.trackBy : null;
            vm.disabled = vm.disabled || (vm.fieldset && vm.fieldset.disabled);
        }

        function onChanges() {
            activate();
        }

        function onInit() {
            activate();
        }
        function getBezeichnung(value) {
            var bezeichnung,
                bezeichnungZusatz,
                dataAdditions = _.get(vm.options, 'dataAdditions');

            if (value) {
                bezeichnung = value[vm.properties.bezeichnung];

                if (dataAdditions && bezeichnung) {
                    bezeichnungZusatz = _.get(_.find(dataAdditions, [vm.properties.trackBy, value[vm.properties.trackBy]]), 'bezeichnung');
                    bezeichnung = _.filter([
                        bezeichnung,
                        bezeichnungZusatz
                    ]).join(' ');
                }
            }

            return bezeichnung || vm.properties.emptyBezeichnungText || 'auswählen';
        }
    }

})();
